import { Component, Inject, Input } from '@angular/core';
import { ArtistsService } from '../artists.service';
import { environment } from 'src/environments/environment';
import { ReleasesBaseComponent } from '../releases-archive/releases.base.component';
import { ActivatedRoute, Router, NavigationEnd, ChildActivationEnd } from '@angular/router';
import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { PlaylistService } from '../playlist.service';
import { SessionService } from '../session.service';
import { Location } from "@angular/common";

@Component({
  selector: 'app-artist-extended-info',
  templateUrl: './artist-extended-info.component.html',
  styleUrls: ['./artist-extended-info.component.scss']
})
export class ArtistExtendedInfoComponent extends ReleasesBaseComponent {
  @Input() artists: any[] = [];
  @Input() clear = () => {};


  constructor(
    private ArtistsService: ArtistsService,
    router: Router,
    location: Location,
    http: HttpClient,
		// @Inject('$rootScope') $rootScope: any,
		PlaylistService: PlaylistService,
	  SessionService: SessionService,
  ) {
    super(router, location, http, PlaylistService, SessionService);
  }
  musicDBapiSrc = environment.musicDBapiSrc;

  artistInfo: any = {};

  showMore(artist) {
    this.artistInfo = artist;
    this.ArtistsService.get(artist.id).subscribe((data) => {
      this.artistInfo = data;
      this.artistInfo.genres = [ ...new Set(data.releases.reduce((acc, i) => [...acc, ...i.genres.map( a => a.genre) ], [] ))]
    })
  }
}
